import { render, staticRenderFns } from "./LpHeader.vue?vue&type=template&id=162e85b3&scoped=true"
import script from "./LpHeader.vue?vue&type=script&lang=js"
export * from "./LpHeader.vue?vue&type=script&lang=js"
import style0 from "./LpHeader.vue?vue&type=style&index=0&id=162e85b3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "162e85b3",
  null
  
)

export default component.exports